import type { ComponentType } from "react";
import { filling } from "@nabla/api";
import { code, Later } from "../../client/index.ts";
import { later } from "../../modules.later.generated.ts";
import { catalog } from "../../modules.generated.ts";

type Props = { readonly page?: string; readonly account?: boolean };
interface Entrance { readonly entrance: () => Promise<{ readonly default: ComponentType<Props> }> }
const entrances = filling<typeof later, "entrance", Entrance>(later, "entrance").map(([name, at]) => [name, code(at.entrance)] as const);

export function PublicEntrances(props: Props) {
  return entrances.map(([name, part]) => <Later key={name} parts={part}>{({ default: Shown }) => <Shown {...props} />}</Later>);
}

interface PublicPlaces {
  readonly public: true;
  readonly pages: readonly { readonly id: string; readonly path: string }[];
  readonly welcome?: string;
}
type Slot = { readonly place: PublicPlaces | { readonly path: string } };
const publicPlaces = filling<typeof catalog, "place", Slot>(catalog, "place")
  .flatMap(([name, { place }]: [string, Slot]) => ("public" in place && place.public ? [[name, place] as const] : []));

export function publicModulePath(path: string): boolean {
  return publicPlaces.some(([, place]) => place.pages.some((page) => page.path === path));
}

export function invitedLanding(on?: readonly string[]): string {
  const [welcome] = publicPlaces.flatMap(([name, place]) => (place.welcome !== undefined && (on === undefined || on.includes(name))
    ? [place.welcome] : []));
  return welcome ?? "/";
}
